module.exports = __webpack_public_path__ + "static/media/gb-nir.42b69bbd.svg";